import React from 'react';
import PropTypes from 'prop-types';

import ResponsiveBGImage from '../../Util/ResponsiveBGImage/ResponsiveBGImage';
import FlagView from '../Flag/FlagView';
import LinkSwitch from '../../Util/LinkSwitch/LinkSwitch';

const StandardHalfTileView = (props) => {
  const url = props.url;

  return (
    <LinkSwitch url={url} key={props.id}>
      <FlagView flag={props.flag} flagColor={props.flagColor} flagOrientation={props.flagOrientation} />
      <ResponsiveBGImage
        className="m-tile__inner"
        src={{
          sm: props.image['1020'],
          md: props.image['515'],
          lg: props.image['620'],
          xl: props.image['620'],
          xxl: props.image['620'],
          xxxl: props.image['2560'],
          default: props.image.default,
        }}
        disableZoom
      >
        {(() => {
          if (!props.disableGradient) {
            return (<div className="m-tile__overlay" />);
          }
          return null;
        })()}
        <div className="m-tile__content">
          <div className={'m-tile__headline'}>{props.headline}</div>
          <div className={'m-tile__subheadline'}>{props.subline}</div>
        </div>
      </ResponsiveBGImage>
    </LinkSwitch>
  );
};

StandardHalfTileView.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  headline: PropTypes.string,
  subline: PropTypes.string,
  disableGradient: PropTypes.bool,
  flag: PropTypes.string,
  flagColor: PropTypes.string,
  flagOrientation: PropTypes.string,
  image: PropTypes.oneOfType([
    PropTypes.shape({
      xxl: PropTypes.string,
      xl: PropTypes.string,
      lg: PropTypes.string,
      md: PropTypes.string,
      sm: PropTypes.string,
      default: PropTypes.string,
    }), PropTypes.array,
  ]),
  url: PropTypes.string,
};

StandardHalfTileView.defaultProps = {
  id: '',
  headline: '',
  subline: '',
  disableGradient: false,
  image: {},
  url: '/',
  flag: '',
  flagColor: 'black',
  flagOrientation: 'left',
};

export default StandardHalfTileView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/DoubleTile/StandardHalfTileView.jsx